import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_document",
  "use": "icon-ic_document-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_document\">\n<path d=\"M9 2.00342V2.00024H19.9978C20.5513 2.00024 21 2.45555 21 2.99204V21.0084C21 21.5562 20.5551 22.0002 20.0066 22.0002H3.9934C3.44476 22.0002 3 21.5503 3 20.9934V8.00024L9 2.00342ZM5.82918 8.00024H9V4.8311L5.82918 8.00024ZM11 4.00024V9.00024C11 9.55252 10.5523 10.0002 10 10.0002H5V20.0002H19V4.00024H11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol